import { selectFromRoutesStatsDto } from '../../models';

export default selectFromRoutesStatsDto()
  .id
  .startDate
  .hasUnpublished
  .active(a => a
    .workingTime
    .load
    .totalDuration
    .totalCapacity
    .distance
    .stopsCount
    .ordersCount
    .routesCount
    .totalIdleTime
    .isOvertime
    .isOverCapacity)
  .published(p => p
    .workingTime
    .load
    .totalDuration
    .totalCapacity
    .distance
    .stopsCount
    .routesCount
    .totalIdleTime
    .isOvertime
    .isOverCapacity)
  .toString();
